import { BillingPeriod, Plan } from '@stigg/js-client-sdk'
import { calcDiscount, roundPrice } from 'hooks'

/**
 * Render plans price text label according to its pricePoints field
 * @param prices
 * @returns Jsx text
 */
export const getPriceLabel = (prices: Plan['pricePoints'], isCustomPrice?: boolean) => {
    let priceLabel = 'Let’s Talk'
    let annualBenefit
    const monthlyPrice = prices.find(({ billingPeriod }) => billingPeriod === BillingPeriod.Monthly)
    const annuallyPrice = prices.find(
        ({ billingPeriod }) => billingPeriod === BillingPeriod.Annually
    )

    if (isCustomPrice) return { priceLabel, annualBenefit }

    if (monthlyPrice?.amount === 0 || annuallyPrice?.amount === 0) {
        priceLabel = `$0 / Forever`
    } else if (monthlyPrice && annuallyPrice) {
        priceLabel = `$${roundPrice(annuallyPrice.amount / 12)} / Month / per user`
    } else if (annuallyPrice) {
        priceLabel = `$${roundPrice(annuallyPrice.amount / 12)} / Month / per user`
        annualBenefit = <>paid annually</>
    }

    if (monthlyPrice && annuallyPrice) {
        const benefit = calcDiscount(annuallyPrice.amount, monthlyPrice.amount)
        annualBenefit = <>paid annually (save {benefit}%)</>
    }

    return { priceLabel, annualBenefit }
}

export const salesLink = 'https://www.guidde.com/contact-sales'
export const defaultPlanId = 'plan-guidde-individual'

/**
 * Makes screen switching in code more readable
 */
export const SCREEN = {
    SelectPlan: 0,
    SelectSeats: 1,
    PaymentConfirmation: 2
}
